import comfybeds from '../Images/comfybeds.svg'
import food from '../Images/food.svg'
import wound from '../Images/wound.svg'
import therapy from '../Images/Therapy.svg'
import staff from '../Images/staff.svg'
import homecare from '../Images/homecare.svg'
export const MyService = [
    {
        "id": "001",
        "title": "Comfy Beds",
        "description": "Comfy beds marked up with ample moving space that's a cross between luxury hotel room and space",
        "link": "Read More",
        "img": comfybeds
    },
    {
        "id": "002",
        "title": "Nutritious Food",
        "description": "Well-equipped kitchen providing personalized nutritious food prepared in consultation with dieticians",
        "link": "Read More",
        "img": food
    },
    {
        "id": "003",
        "title": "Wound Managment",
        "description": "Bed-sore and wound managment facility is available with professional and well-equipped staff",
        "link": "Read More",
        "img": wound
    },
    {
        "id": "004",
        "title": "Physical Therapy",
        "description": "Customized physical therapy for speedu recovery and mobility",
        "link": "Read More",
        "img": therapy
    },
    {
        "id": "005",
        "title": "Professional Staff",
        "description": "Complete support from highly qualified professional staff and care givers",
        "link": "Read More",
        "img": staff
    },
    {
        "id": "006",
        "title": "Home Care",
        "description": "We provide home care to your beloved, and make them feel like home",
        "link": "Read More",
        "img": homecare
    },
]